<div class="sol-popover-menu-item-icon">
  @if (icon$() !== undefined) {
    <sol-icon [name]="icon$()" />
  }
</div>
<div class="sol-popover-menu-item-text" tabindex="0" role="menuitem" #text (focus)="onFocused()">
  @if (translatable$()) {
    {{ text$() | translate: params$() }}
  } @else {
    {{ text$() }}
  }
</div>
<div class="sol-popover-menu-item-suffix" [class.sol-popover-menu-item-suffix-hidden]="!shortcut$() && !hint$()">
  @if (hint$()) {
    @if (translatable$()) {
      {{ hint$() | translate }}
    } @else {
      {{ hint$() }}
    }
  } @else {
    <sol-shortcut [shortcut]="shortcut$()"></sol-shortcut>
  }
</div>
